import tw from 'tailwind-styled-components'
import {getLabelDefault, getLabelDisabled} from './classes/label-class'
import {getDefault, getDisabled} from './classes/main-class'
import {getSupportDefault, getSupportDisabled} from './classes/support-class'
import {TwIconType, TwTextAreaType} from './types'
import {getDefaultTextColor, getIconSize} from './utils'

export const TwTextAreaHeight = tw.div<TwTextAreaType>`
  w-full
  h-fit
  min-h-20
  whitespace-pre-wrap
  text-transparent

  break-words
  py-0
  ${p => getIconSize(p.$leftIcon, p.$rightIcon, p.$paddings)}

  ${p => {
    if (p.$textSize === 'small') {
      return 'text-xs-regular'
    }
    return 'text-sm-regular'
  }}
`

export const TwTextArea = tw.textarea<TwTextAreaType>`
  absolute
  top-0
  left-0
  w-full
  h-full
  z-1

  outline-none
  shadow-none
  resize-none
  overflow-hidden
  focus:shadow-none
  bg-transparent
  focus:bg-transparent

  rounded-4
  transition
  duration-100
  ease-linear
  border-solid
  active:outline
  focus:outline
  cursor-text

  placeholder-placeholder
  box-border
  flex-1
  break-words
  py-0

  ${p =>
    p.$borders
      ? `outline-2 active:outline-2 focus:outline-2 border-1 active:border-1 focus:border-1`
      : `outline-0 active:outline-0 focus:outline-0 border-0 active:border-0 focus:border-0`}

  ${p => {
    if (p.$textSize === 'small') {
      return 'text-xs-regular'
    }
    return 'text-sm-regular'
  }}

  ${p => getDefaultTextColor(p.$color)}

  ${p => {
    if (p.$disabled) {
      return getDisabled(p.$hasError, p.$isSuccess)
    }
    if (p.$noBackground) {
      return 'bg-transparent focus:bg-transparent active:bg-transparent'
    }
    return getDefault(p.$hasError, p.$isSuccess)
  }}

  ${p => getIconSize(p.$leftIcon, p.$rightIcon, p.$paddings)}
`

export const TwTextAreaLite = tw.textarea<TwTextAreaType>`
  outline-none
  shadow-none
  resize-none
  focus:shadow-none
  bg-transparent
  focus:bg-transparent

  ${p => p.$autoHeight && 'overflow-hidden'}
  
  outline-0
  active:outline-0
  focus:outline-0 

  rounded-4
  transition
  duration-100
  ease-linear
  border-solid
  active:outline
  focus:outline
  cursor-text

  placeholder-placeholder
  box-border
  flex-1
  break-words
  py-0
  
  px-12
  pt-7

  ${p =>
    p.$borders
      ? `border-1 active:border-1 focus:border-1`
      : `border-0 active:border-0 focus:border-0`}

  ${p => {
    if (p.$textSize === 'small') {
      return 'text-xs-regular'
    }
    return 'text-sm-regular'
  }}

  ${p => getDefaultTextColor(p.$color)}

  ${p => {
    if (p.$disabled) {
      return getDisabled(p.$hasError, p.$isSuccess)
    }
    if (p.$noBackground) {
      return 'bg-transparent focus:bg-transparent active:bg-transparent'
    }
    return getDefault(p.$hasError, p.$isSuccess)
  }}
`

export const TwWrap = tw.div`
  flex
  gap-4
  items-start
  flex-col
`

export const TwLabel = tw.div<TwTextAreaType>`
  text-sm-regular
  text-secondary
  truncate
  cursor-default
  ${p =>
    p.$disabled ? getLabelDisabled(p.$hasError) : getLabelDefault(p.$hasError)}
`

export const TwSupport = tw.div<TwTextAreaType>`
  micro-semibold
  truncate
  ${p =>
    p.$disabled
      ? getSupportDisabled(p.$hasError)
      : getSupportDefault(p.$hasError)}
`

export const TwIconLeft = tw.div<TwIconType>`
  absolute
  h-full
  flex
  items-start
  z-20
  text-secondary

  ${p => getDefaultTextColor(p.$color)}

  ${p => {
    if (p.$paddings === 'medium') {
      return 'left-12'
    }
    if (p.$paddings === 'none') {
      return 'left-0'
    }
    return 'left-12'
  }}
`

export const TwIconRight = tw.div<TwIconType>`
  absolute
  h-full
  flex
  items-center
  z-20
  text-secondary

  ${p => getDefaultTextColor(p.$color)}

  ${p => {
    if (p.$paddings === 'medium') {
      return 'right-12'
    }
    if (p.$paddings === 'none') {
      return 'right-0'
    }
    return 'right-12'
  }}
`
